angular.module('core')
  .service('edxReportItemService', [function() {
    var self = this;

    // A subject that emits every report item.  This is useful
    // for directives like the navigation tabs that only load once
    // with the reporting section of the site
    var _itemSubject = new Rx.ReplaySubject(1);

    // A subject for the current item chosen in the nav.  This is used
    // for components in the right pane that load one or more times per reporting item.
    // A high level controller must make sure this is set in time for components
    // to use it.
    var _currentItemSubject;

    self.setCurrentItemSubject = function (currentItemSubject) {
      _currentItemSubject = currentItemSubject;
    };

    self.setItem = function (item) {
      _itemSubject.onNext(item);
      _currentItemSubject.onNext(item);
    };

    // emits every item
    self.getItemObservable = function () {
      return _itemSubject;
    };

    // emits the latest item chosen in the nav
    self.getCurrentItemObservable = function () {
      return _currentItemSubject;
    };
  }]);
